import { mobileAppUtil } from '../mobileAppUtil';

var gaTracker = function gaTracker(data) {
  return ""; // const gtm = {
  //     ...data,
  //     event: data.event,
  //     gtm: {
  //         start: '',
  //         element: '',
  //         elementClasses: '',
  //         elementId: '',
  //         elementTarget: '',
  //         elementUrl: '',
  //         elementText: '',
  //         ...data.gtm
  //     }
  // };
  // function flattenObject(ob) {
  //   var toReturn = {};
  //   for (var i in ob) {
  //       if (!ob.hasOwnProperty(i)) continue;
  //       if ((typeof ob[i]) == 'object' && ob[i] !== null) {
  //           var flatObject = flattenObject(ob[i]);
  //           for (var x in flatObject) {
  //               if (!flatObject.hasOwnProperty(x)) continue;
  //               toReturn[i + '.' + x] = flatObject[x];
  //           }
  //       } else {
  //           toReturn[i] = ob[i];
  //       }
  //   }
  //   return toReturn;
  // }
  // const flatData = flattenObject(gtm)
  // return pushToDataLayer(flatData);
};

var gaDefault = function gaDefault(uniqueEventId) {
  var elementTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var data = {
    gtm: {
      uniqueEventId: uniqueEventId,
      elementTarget: elementTarget
    }
  };
  gaTracker(data); // console.log({ data });
};

var count = 0;

var pushToDataLayer = function pushToDataLayer(data) {
  if (mobileAppUtil === null || mobileAppUtil === void 0 ? void 0 : mobileAppUtil.isMobileApp()) {
    mobileAppUtil.firebaseUtil.convertToFirebaseEvent(data);
    return;
  }

  if (window.dataLayer) {
    return window.dataLayer.push(data);
  }

  if (count > 3) {
    return console.log("No data layer found");
  }

  count++;
  return setTimeout(function () {
    return pushToDataLayer(data);
  }, 250);
  ;
};

export { gaTracker, gaDefault, pushToDataLayer };
export default gaTracker;